import { GD } from "src/GD";

export class AgentsService {
	constructor() {
		GD.REQ_AGENTS.listener = this.getAgents;
		GD.REQ_CREATE_AGENT.listener = this.createAgent;
		GD.REQ_GET_AGENT.listener = this.getAgent;
		GD.REQ_GET_AGENT_TEMPLATE.listener = this.getAgentTemplate;
		GD.REQ_UPDATE_AGENT.listener = this.updateAgent;
	}

	private getAgents: () => Promise<IAPIResponse<IAgentSaved[]>> = async () => {
		const res = await GD.REQ_API.request({
			httpMethod: "GET",
			method: "agents/list",
		});

		return res as IAPIResponse<IAgentSaved[]>;
	};

	private getAgent: (id: string) => Promise<IAPIResponse<IAgentSaved>> = async id => {
		const res = await GD.REQ_API.request({
			httpMethod: "GET",
			method: `agents/get?uid=${id}`,
		});
		return res as IAPIResponse<IAgentSaved>;
	};

	private getAgentTemplate: () => Promise<IAPIResponse<IAgentRaw>> = async () => {
		const res = await GD.REQ_API.request({
			httpMethod: "GET",
			method: "agents/get?uid=-1",
		});
		return res as IAPIResponse<IAgentRaw>;
	};

	private updateAgent: (date: IAgentSaved) => Promise<IAPIResponse<boolean>> = async data => {
		const res = await GD.REQ_API.request({
			method: "agents/update",
			httpMethod: "POST",
			data,
		});
		if ((res.data as any)?.error) return { data: false };
		if ((res.data as unknown as boolean) === true) return { data: true };
		return { error: { code: -1, message: "Unknown error" } };
	};

	private createAgent: (data: IAgentRaw) => Promise<IAPIResponse<IAgentRaw>> = async data => {
		const res = await GD.REQ_API.request({
			method: "agents/register",
			httpMethod: "POST",
			data,
		});
		if ((res.data as any)?.error) return res.data as IAPIResponse<IAgentRaw>;
		if (res.data && "uid" in (res.data as any)) return res.data as IAPIResponse<IAgentRaw>;
		return { error: { code: -1, message: "Unknown error" } };
	};
}
